import React, { Component } from "react";
import styles from "./monitoringTaskTripUnitsBar.module.scss";
import MonitoringTripUnitItem from "./MonitoringTripUnitItem";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import MonitoringTripRoutesUnitItem from "./MonitoringTripRoutesUnitItem";

class MonitoringTripUnitListItems extends Component {
  render() {
    const { handleScrollTo, data, monitoringSettingsState } = this.props;

    return data.map((item) => {
      return (
        <div className={styles.container_userUnitsListItem} key={item.id}>
          {monitoringSettingsState.modificationType === 0 ? <MonitoringTripUnitItem data={item} handleScrollTo={handleScrollTo} /> : null}
          {monitoringSettingsState.modificationType === 1 ? (
            <MonitoringTripRoutesUnitItem data={item} handleScrollTo={handleScrollTo} />
          ) : null}
        </div>
      );
    });
  }
}

export default withMonitoringTaskTrips(React.memo(MonitoringTripUnitListItems));
